<template>
	<v-row justify="center">
		<v-dialog v-if="dialog_serial" v-model="dialog_serial" persistent max-width="700" scrollable content-class="modal-schedule">
			<v-card>
				<v-card-title class="h6 pt-3 pb-3">List Serial {{ name }}</v-card-title>
        <v-alert v-for="(msg, index) in message" :key="index" v-model="msg.show" dense dismissible type="error" elevation="1">
          {{msg.msg}}
        </v-alert>
				<v-card-text class="pb-1" v-for="(serialType, indexserial) in type" :key="indexserial">
					<v-col class="px-0 pt-2">
						<v-text-field label="Kode Serial" clearable autofocus @keypress.enter="checkSerial(serialType)" v-model="serialType.serial" :ref="'inputSerial'+indexserial" append-outer-icon="mdi-magnify" :error-messages="responseError.serial"  @focus="responseError.serial = ''" @click:append-outer="checkSerial(serialType)"></v-text-field>
						<div v-show="false">Belum ada serial dipilih</div>
					</v-col>
					<v-col class="px-0">
            <div class="font-weight-bold">Serial {{serialType.serial_name}} {{serialType.serial_array.length}} dari {{serialType.quantity * quantity}}</div>
						<v-row>
							<v-col cols="4" v-for="(item, index) in serialType.serial_array" :key="index">
								<span class="pr-1">{{item}}</span>
								<v-btn class="mr-2" fab dark x-small depressed color="pink" @click="removeSerial(indexserial, index)">
									<v-icon dark>mdi-delete</v-icon>
								</v-btn>
							</v-col>
						</v-row>
					</v-col>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="grey darken-1" outlined class="text-capitalize" @click="hideModal">Tutup</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import { mapState } from 'vuex'

export default {
	data () {
		return {
			dialog_serial: false,
			message: [],
			serial: '',
			serialScan: [],
		}
	},
	props: {
		value: Boolean,
		edit: String,
		quantity: Number,
		type: {
      type: Array,
      default: function () {
        return []
      }
    },
		name: String,
	},
	computed: {
		...mapState('productRecall', ['response', 'responseError', 'alertMultiple']),
	},
	methods: {
		checkSerial(serial) {
			this.saveSerial(serial)
		},
		removeSerial(indexserial, index) {
			this.type[indexserial].serial_array.splice(index, 1)
		},
		showModal () {
			this.message = []
			this.serialScan = []
			this.serial = ''
			this.dialog_serial = true
		},
		showMessage(msg) {
			this.message = msg
		},
		hideModal (){
			this.dialog_serial = false
		},
		saveSerial(serial) {
			if (serial.serial) {
				this.$emit('saveSerial', serial)
			}
		}
	},
	watch: {
	},
}
</script>
<style>
.container-scanner {
	max-width: 400px;
	max-height: 300px;
}
.qrcode-stream-wrapper video {
	transform: scaleX(-1) !important;
}
</style>
